"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const messageStyle = (0, _styledSystem.variant)({
  key: "messages"
});

const Message = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "Message",
  componentId: "sc-1jq05xi-0"
})(["", ";"], messageStyle);

Message.defaultProps = {
  variant: "default",
  p: 2,
  border: 1,
  borderRadius: 4
};

/** @component */
exports.default = Message;